module.exports = __webpack_public_path__ + "static/img/IMG_20150610_225603.7ec70e03.jpg";